import { useContext } from 'react';
import { TeamDrawerContext } from '../contexts/teamDrawerContextValue';
import type { TeamDrawerContextValue } from '../contexts/TeamDrawerContext.types';

export function useTeamDrawer(): TeamDrawerContextValue {
  const ctx = useContext(TeamDrawerContext);
  if (!ctx) throw new Error('useTeamDrawer must be used within TeamDrawerProvider');
  return ctx;
}
